import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { createSelector, Store } from '@ngrx/store';

import { MfaType } from '@ninety/platform/models/auth/mfaType.enum';
import { LogOutActions, LoginActions, MfaTotpVerificationFlow } from '@ninety/platform/state';
import { AuthStateSelectors } from '@ninety/platform/state/app-global/auth/auth.selectors';
import { TerraIconModule, TerraFormFieldModule, TerraTextInputModule } from '@ninety/terra';

import { LoginSharedStateFacade } from '../../_state/shared/login-shared-state.facade';

import { TotpComponent } from './totp.component';

@Component({
  selector: 'ninety-setup-totp',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    TerraIconModule,
    TerraTextInputModule,
    TerraFormFieldModule,
    TotpComponent,
  ],
  templateUrl: './totp-setup.component.html',
  styleUrls: ['./totp-setup.component.scss'],
})
export class TotpSetupComponent {
  private readonly store = inject(Store);
  protected readonly loginState = inject(LoginSharedStateFacade);
  public readonly MfaTotpVerificationFlow = MfaTotpVerificationFlow;
  public vm = this.store.select(selectSetupTotpVM);

  onBack() {
    this.store.dispatch(LogOutActions.initiateLogOut());
  }

  onSkip() {
    this.store.dispatch(LoginActions.redirectToApp({ response: null }));
  }
}

export const selectSetupTotpVM = createSelector(
  AuthStateSelectors.cognitoUserAttributes,
  AuthStateSelectors.mfaPreferences,
  (attributes, mfaPreferences) => {
    const personIsFederated = attributes ? !!attributes?.identities : false;
    const mfaTotpEnabled = mfaPreferences?.enabled?.includes(MfaType.TOTP) ? true : false;

    return {
      personIsFederated,
      mfaTotpState: mfaTotpEnabled,
    };
  }
);
